
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "ae5a2481e6d3f51266c1d603c7d29ec95490e687",
  "nuxt": {
    "buildId": "a2889091-6f56-4850-ab18-a0e54f339852"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
